module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-packet-vehicle-category-modal"
  }, [_c('ModalReveal', {
    key: _vm.key,
    ref: "packetCategoryModal",
    on: {
      "input": _vm.closeInput
    }
  }, [_vm._t("default", [_c('a', {
    staticClass: "fa-stack fa-lg"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })])], {
    "slot": "trigger"
  }), _c('div', {
    staticClass: "body"
  }, [_c('h2', [_vm._v("Assign packet to category")]), (_vm.packetCategory) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-4"
  }, [_c('label', [_vm._v("Packet Vehicle Category id:")]), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.packetCategory.id
    }
  })]), _c('div', {
    staticClass: "columns large-4"
  }, [_c('label', [_vm._v("Packet id:")]), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.selectedPacket
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [(!_vm.packetCategory) ? _c('div', {
    staticClass: "columns large-4"
  }, [_c('SelectizePacket', {
    on: {
      "optionSelected": _vm.selectPacket
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "columns large-4"
  }, [_c('SelectizeCategory', {
    attrs: {
      "selectedValue": _vm.selectedCategory
    },
    on: {
      "optionSelected": _vm.selectCategory
    }
  })], 1)])]), _c('div', {
    staticClass: "row columns",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70a3ae41!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/PacketVehicleCategoryModal.vue
// module id = 2569
// module chunks = 1